import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=0606f855&"
import script from "./Select.vue?vue&type=script&lang=js&"
export * from "./Select.vue?vue&type=script&lang=js&"
import style0 from "./Select.vue?vue&type=style&index=0&id=0606f855&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports